import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { useTraderRoomRoutesConditions } from '../../../../Traders-Room/TradersRoomRoutes'
import { PagesIcon } from '../../../../icons/PagesIcon'
import { TickmillProductType } from '../../../../model/TickmillProductType'
import { MenuSection } from '../useMenuSections'

export const useStatementsMenu = (): MenuSection => {
  const { t } = useTranslation()

  const { isTradersRoomVisible } = useTraderRoomRoutesConditions()

  return useMemo(
    () => ({
      id: 'statements',
      label: t('Tabs.Statements'),
      icon: PagesIcon,
      condition: isTradersRoomVisible,
      products: [TickmillProductType.ETD],
      children: [
        {
          id: 'daily',
          label: t('Statements.Daily'),
          path: '/dashboard/statements/daily',
        },
        {
          id: 'monthly',
          label: t('Statements.Monthly'),
          path: '/dashboard/statements/monthly',
        },
      ],
    }),
    [t, isTradersRoomVisible]
  )
}
